import { loadPhoneFromUrlOrStorage } from "./urlPhone";

  const _0x8fdf = "PR1026FRyut67HGKJhy45tyuHGKJhy45tyu";
  export async function encryptScore(score: string): Promise<string> {
    const timeNow = Date.now().toString();
    //add timeNow to score for added variability
    score = score + '|' + timeNow;

    const encoder = new TextEncoder();
    const keyMaterial = await crypto.subtle.importKey(
      "raw",
      encoder.encode(_0x8fdf),
      { name: "PBKDF2" },
      false,
      ["deriveKey"]
    );

    const key = await crypto.subtle.deriveKey(
      {
        name: "PBKDF2",
        salt: encoder.encode("c4a9b7e2d1f8c36ab9e0d25fc7a1b4e8"), // could randomize per session
        iterations: 100000,
        hash: "SHA-256",
      },
      keyMaterial,
      { name: "AES-GCM", length: 256 },
      false,
      ["encrypt"]
    );

    const iv = crypto.getRandomValues(new Uint8Array(12));
    const encrypted = await crypto.subtle.encrypt(
      { name: "AES-GCM", iv },
      key,
      encoder.encode(score.toString())
    );

    // Convert ArrayBuffers to Base64 for easy sending
    const ivBase64 = btoa(String.fromCharCode(...Array.from(iv)));
    const encryptedBase64 = btoa(String.fromCharCode(...Array.from(new Uint8Array(encrypted))));

    return `${ivBase64}:${encryptedBase64}`;
  }

  //decrypt function (not used here, but provided for completeness)
  export async function decryptScore(encryptedData: string): Promise<string> {
    const [ivBase64, encryptedBase64] = encryptedData.split(":");
    const iv = Uint8Array.from(atob(ivBase64), c => c.charCodeAt(0));
    const encrypted = Uint8Array.from(atob(encryptedBase64), c => c.charCodeAt(0));
    const encoder = new TextEncoder();

    const keyMaterial = await crypto.subtle.importKey(
      "raw",
      encoder.encode(_0x8fdf),
      { name: "PBKDF2" },
      false,
      ["deriveKey"]
    );
    const key = await crypto.subtle.deriveKey(
      {
        name: "PBKDF2",
        salt: encoder.encode("c4a9b7e2d1f8c36ab9e0d25fc7a1b4e8"),
        iterations: 100000,
        hash: "SHA-256",
      },
      keyMaterial,
      { name: "AES-GCM", length: 256 },
      false,
      ["decrypt"]
    );

    const decrypted = await crypto.subtle.decrypt(
      { name: "AES-GCM", iv },
      key,
      encrypted
    );

    return new TextDecoder().decode(decrypted);
  }

  // 📤 Submit encrypted score to server
  export async function sendScore(score: number, gameId: string) {
    const encryptedScore = await encryptScore(score.toString());
    let phone = loadPhoneFromUrlOrStorage();
    if (!phone) {
      console.warn("No valid phone number found, score not sent.");
      return null;
    }
    phone = await encryptScore(phone);
    try {
      const response = await fetch("https://api.happygameskenya.com/api/html/record", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          p: phone,
          g: gameId,
          s: encryptedScore,
        }),
      });

      const data = await response.json();
      console.log("Server response:", data);
      return data;
    } catch (err) {
      console.error("Failed to send score:", err);
      return null;
    }
  }


